<template>
  <div class="main-wrapper" :style="{ height: isH5 ? '100vh' : 'calc(100vh - 68px)' }">
    <import-task ref="importTask">
      <template slot="header">
        <search-box class="search-box">
          <el-form :inline="true" size="mini">
            <el-form-item label="日期">
              <form-date-range
                :form="form"
                startKey="startDate"
                :usingTime="false"
                endKey="endDateStr"
                valueFormat="yyyy-MM-dd HH:mm:ss"
              />
            </el-form-item>
          </el-form>
          <template v-slot:right>
            <el-button type="primary" size="small" @click="handleSearch">搜索</el-button>
          </template>
        </search-box>
      </template>
      <template slot="main-header">
        <el-button type="primary" size="mini" @click="showExport">批量导入</el-button>
      </template>
    </import-task>

    <el-dialog
      :title="titleName"
      width="800px"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
    >
      <div slot="footer" class="dialog-footer">
        <el-form :model="requestParam" :rules="rules" ref="requestParam" :inline="true">
          <el-row>
            <el-col :span="24" align="left">
              <el-form-item label="附件" prop="goodsCode" label-width="40px">
                <el-upload
                  class="upload-demo"
                  ref="upload"
                  accept=".xls,.xlsx,.xls.ttt,.xlsx.ttt"
                  :limit="1"
                  action
                  :auto-upload="false"
                  :http-request="upload"
                  :on-change="onFileChange"
                  :on-remove="handleRemove"
                  :headers="headers"
                  :file-list="fileList"
                  :before-upload="beforeUpload"
                >
                  <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                  <el-button
                    style="margin-left: 10px;"
                    v-loading.fullscreen.lock="fjLoading"
                    element-loading-text="数据导入中"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(0, 0, 0, 0.8)"
                    size="small"
                    type="success"
                    @click="submitUpload"
                    >上传</el-button
                  >
                  <div slot="tip" class="el-upload__tip">只能上传xls/xlsx文件，且只能上传一个</div>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-button @click="cancel" size="medium">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getToken } from '@/utils/auth'
import pagePathMixin from '@/utils/page-path-mixin'
import axios from '@/utils/axios'

const PAGE_MAP = {
  stockImport: {
    name: '库存导入',
    reportName: 'stockImport' 
  },
  firstBatchImport: {
    name: '首批需求导入',
    reportName: 'firstBatchImport'
  },
  supplierStockAgeImport: {
    name: '库龄导入',
    reportName: 'supplierStockAgeImport'
  },
  jdPlatformSubsidyDayImport: {
    name: '京东自营平台补贴额日数据导入',
    reportName: 'jdPlatformSubsidyDailyImport'
  },
  jdPlatformSubsidyFactoryImport: {
    name: '京东自营平台补贴额京东厂送导入',
    reportName: 'jdPlatformSubsidyMonthlyImport'
  },
  jdPlatformSubsidyDetailImport: {
    name: '订单平台补贴额明细导入',
    reportName: 'jdPlatformSubsidyDetailImport'
  }
}

export default {
  name: 'IocCommonImport',
  mixins: [pagePathMixin],
  data() {
    return {
      form: {
        startDate: '',
        endDate: '',
        endDateStr: '',
        reportName: ''
      },
      dialogFormVisible: false,
      titleName: '',
      requestParam: {},
      headers: { Authorization: getToken() },
      fileList: [],
      rules: {},
      fjLoading: false
    }
  },
  computed: {
    pageObj() {
      const type = this.$route.params.type || 'stockImport'
      return {
        name: PAGE_MAP[type].name,
        reportName: PAGE_MAP[type].reportName
      }
    },
    isH5() { 
      // /ioc-import/stockImport
      return this.$route.path.includes('ioc-import')
    }
  },
  methods: {
    handleSearch() {
      this.form.endDate = !this.form.endDateStr
        ? this.form.endDateStr
        : this.form.endDateStr.substr(0, 10) + ' 23:59:59'
      this.$refs['importTask'].init(this.form)
    },
    showExport() {
      this.fileList = []
      this.dialogFormVisible = true
      this.titleName = this.pageObj.name + '批量维护'
    },
    cancel() {
      this.dialogFormVisible = false
    },
    handleRemove() {
      this.fileList = []
    },
    onFileChange(file) {
      if (file) {
        this.fileList = [file]
      }
    },
    beforeUpload(file) {
      const pattern = file.name.substring(file.name.lastIndexOf('.') + 1)
      if (['xls', 'xlsx', 'xls.ttt', 'xlsx.ttt'].indexOf(pattern.toLowerCase()) === -1) {
        this.$message.error('请上传后缀名为.xls,.xlsx的附件！')
        return false
      }
      this.fileList = []
      this.fileList.push(file)
      return true
    },
    upload({ file }) {
      this.fjLoading = true
      const taskDTO = {
        reportName: this.form.reportName,
        appCode: this.$route.query.appCode || 'ioc-cds-data-query'
      }
      const formData = new FormData()
      formData.append('file', file)
      formData.append('taskDTO', JSON.stringify(taskDTO))
      axios.request({
        url: '/qu-platform-excel-api/excel/import/task',
        method: 'post',
        data: formData
      }).then(({ code, message }) => {
        if (code === 200) {
          this.$message.success('数据导入中，请稍后')
          this.cancel()
          this.handleSearch()
          this.fjLoading = true
          return
        }
        this.$message.error(message)
      }).finally(() => {
        this.fjLoading = false
      })
    },
    submitUpload() {
      if (!this.fileList || this.fileList.length === 0) {
        this.$message.error('请先上传Excel附件')
        return
      }
      this.$refs.upload.submit()
    },
    updateTagTitle() {
      setTimeout(() => {
        this.$store.dispatch('tagsView/updateVisitedView', {
          ...this.$route,
          title: this.pageObj.name,
          meta: { title: this.pageObj.name }
        })
      }, 300)
    }
  },
  created() {
    document.title = this.pageObj.name
  },
  mounted() {
    this.form.reportName = this.pageObj.reportName
    this.handleSearch()
    this.updateTagTitle()
  }
}
</script>

<style lang="stylus" scoped>
.main-wrapper
  height calc(100vh - 68px)
>>> .el-header
  height 39px !important
  margin-bottom 5px
  padding 0
.main-wrapper >>> .root 
  padding 5px !important
</style>
